import React from "react";
import { PenLine, Layers, MessageCircle } from "lucide-react";

const STEPS = [
  { icon: PenLine, title: "Write the exact question", text: "The one you keep turning over — the job, the move, the person." },
  { icon: Layers, title: "Draw your cards", text: "Pick a deck and spread. Each card lands in a position: past, present, future, or deeper." },
  { icon: MessageCircle, title: "Get a reading about your question", text: "The AI reads every card you drew, its position and whether it's reversed, against what you asked." },
];

export const HowItWorks = () => (
  <section className="mb-10" data-testid="how-it-works" aria-labelledby="how-heading">
    <h2 id="how-heading" className="font-display text-2xl font-medium text-[#F8F3E6]">
      Stuck on something you can't talk through with anyone?
    </h2>
    <p className="mt-2 max-w-2xl text-sm leading-relaxed text-[#A3A5B8]">
      Write the exact question. The oracle reads your cards against it — not a generic paragraph
      that could apply to almost anyone.
    </p>
    <ol className="mt-5 grid gap-4 sm:grid-cols-3">
      {STEPS.map(({ icon: Icon, title, text }, i) => (
        <li key={title} className="rounded-xl border border-[#D9A441]/15 bg-[#131422]/50 p-5" data-testid={`how-step-${i + 1}`}>
          <Icon className="h-5 w-5 text-[#D9A441]" strokeWidth={1.5} />
          <p className="mt-3 font-medium text-[#F8F3E6]">{title}</p>
          <p className="mt-1 text-sm leading-relaxed text-[#A3A5B8]">{text}</p>
        </li>
      ))}
    </ol>
  </section>
);
